import request from '@/utils/request'

export function getIndependentSystemList() {
  return request({
    url: '/system/getIndependentSystemList',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/system.js